import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, CheckCircle, Users, BarChart, Award } from 'lucide-react';
import { useForm, ValidationError } from '@formspree/react';
export function SponsorshipPage() {
  // Using the provided Formspree ID
  const [state, handleSubmit] = useForm('mzzjzkpj');
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    sponsorshipLevel: '',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real application, you would handle form submission here
    alert('Thank you for your interest in sponsoring the Commerce CFO Roundtable! Our team will contact you shortly.');
    setFormData({
      name: '',
      company: '',
      email: '',
      phone: '',
      sponsorshipLevel: '',
      message: ''
    });
  };
  const sponsorshipLevels = [{
    title: 'Platinum',
    price: '$10,000',
    benefits: ['Premier logo placement on all event materials', 'Speaking opportunity', '1 complimentary event pass', 'Access to attendee list with contact information', 'Featured in post-event recap materials', 'Opportunity to provide branded gift items']
  }, {
    title: 'Gold',
    price: '$5,000',
    benefits: ['Prominent logo placement on event materials', '1 complimentary event pass', 'Access to attendee list (name and company only)', 'Mentioned in post-event recap materials']
  }, {
    title: 'Silver',
    price: '$2,500',
    benefits: ['Logo on event materials', 'Company mentioned during event']
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-177">
      <Header data-id="element-178" />
      <main data-id="element-179">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-gray-900" data-id="element-180">
          <div className="absolute inset-0 z-0 opacity-30" data-id="element-181">
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Business meeting" className="w-full h-full object-cover" data-id="element-182" />
          </div>
          <div className="container relative z-10 mx-auto px-4 md:px-6 text-white" data-id="element-183">
            <div className="max-w-3xl" data-id="element-184">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-185">
                Sponsorship Opportunities
              </h1>
              <p className="text-xl md:text-2xl font-light mb-8" data-id="element-186">
                Connect your brand with top brand and fractional CFOs at the
                exclusive Commerce CFO Roundtable 2025
              </p>
              <a href="#sponsorship-packages" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-medium px-6 py-3 rounded-md transition-colors" data-id="element-187">
                View Sponsorship Packages
                <ChevronRight size={18} data-id="element-188" />
              </a>
            </div>
          </div>
        </section>
        {/* Benefits Section */}
        <section className="py-20 bg-white" data-id="element-189">
          <div className="container mx-auto px-4 md:px-6" data-id="element-190">
            <div className="text-center mb-16" data-id="element-191">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-192">
                Why Sponsor the Commerce CFO Roundtable?
              </h2>
              <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-193"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto" data-id="element-194">
              <div className="text-center" data-id="element-195">
                <div className="flex justify-center mb-4" data-id="element-196">
                  <Users className="text-red-600" size={48} data-id="element-197" />
                </div>
                <h3 className="text-xl font-semibold mb-3" data-id="element-198">Exclusive Access</h3>
                <p className="text-gray-600" data-id="element-199">
                  Connect directly with 50+ brand and fractional CFOs and senior
                  finance executives from leading companies
                </p>
              </div>
              <div className="text-center" data-id="element-200">
                <div className="flex justify-center mb-4" data-id="element-201">
                  <BarChart className="text-red-600" size={48} data-id="element-202" />
                </div>
                <h3 className="text-xl font-semibold mb-3" data-id="element-203">Brand Visibility</h3>
                <p className="text-gray-600" data-id="element-204">
                  Showcase your brand to decision-makers in a premium, intimate
                  setting
                </p>
              </div>
              <div className="text-center" data-id="element-205">
                <div className="flex justify-center mb-4" data-id="element-206">
                  <Award className="text-red-600" size={48} data-id="element-207" />
                </div>
                <h3 className="text-xl font-semibold mb-3" data-id="element-208">
                  Thought Leadership
                </h3>
                <p className="text-gray-600" data-id="element-209">
                  Position your company as a leader in financial innovation and
                  strategy
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Sponsorship Packages */}
        <section id="sponsorship-packages" className="py-20 bg-gray-50" data-id="element-210">
          <div className="container mx-auto px-4 md:px-6" data-id="element-211">
            <div className="text-center mb-16" data-id="element-212">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-213">
                Sponsorship Packages
              </h2>
              <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-214"></div>
              <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-215">
                Choose the package that best aligns with your marketing
                objectives and budget
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-216">
              {sponsorshipLevels.map((level, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-217">
                  <div className="bg-gray-900 text-white p-6 text-center" data-id="element-218">
                    <h3 className="text-2xl font-bold" data-id="element-219">{level.title}</h3>
                    <p className="text-3xl font-bold mt-2" data-id="element-220">{level.price}</p>
                  </div>
                  <div className="p-6" data-id="element-221">
                    <ul className="space-y-3" data-id="element-222">
                      {level.benefits.map((benefit, i) => <li key={i} className="flex items-start" data-id="element-223">
                          <CheckCircle className="text-red-600 mr-2 shrink-0 mt-1" size={16} data-id="element-224" />
                          <span className="text-gray-700" data-id="element-225">{benefit}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Contact Form */}
        <section id="contact" className="py-20 bg-white" data-id="element-226">
          <div className="container mx-auto px-4 md:px-6" data-id="element-227">
            <div className="max-w-4xl mx-auto" data-id="element-228">
              <div className="text-center mb-16" data-id="element-229">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-230">
                  Become a Sponsor
                </h2>
                <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-231"></div>
                <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-232">
                  Interested in sponsoring the Commerce CFO Roundtable? Fill out
                  the form below and our team will contact you with more
                  information.
                </p>
              </div>
              {state.succeeded ? <div className="bg-gray-50 rounded-lg shadow-md p-8 text-center" data-id="element-233">
                  <div className="mb-6 text-green-600" data-id="element-234">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-235">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-236" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4" data-id="element-237">Thank You!</h3>
                  <p className="text-lg mb-6" data-id="element-238">
                    Your sponsorship inquiry has been received. We will send you
                    event information within 24 hours.
                  </p>
                </div> : <div className="bg-gray-50 rounded-lg shadow-md p-8" data-id="element-239">
                  <form onSubmit={handleSubmit} data-id="element-240">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-241">
                      <div data-id="element-242">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-243">
                          Full Name*
                        </label>
                        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-244" />
                        <ValidationError prefix="Name" field="name" errors={state.errors} data-id="element-245" />
                      </div>
                      <div data-id="element-246">
                        <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-247">
                          Company*
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-248" />
                        <ValidationError prefix="Company" field="company" errors={state.errors} data-id="element-249" />
                      </div>
                      <div data-id="element-250">
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-251">
                          Email Address*
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-252" />
                        <ValidationError prefix="Email" field="email" errors={state.errors} data-id="element-253" />
                      </div>
                      <div data-id="element-254">
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-255">
                          Phone Number*
                        </label>
                        <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-256" />
                        <ValidationError prefix="Phone" field="phone" errors={state.errors} data-id="element-257" />
                      </div>
                      <div className="md:col-span-2" data-id="element-258">
                        <label htmlFor="sponsorshipLevel" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-259">
                          Interested Sponsorship Level
                        </label>
                        <select id="sponsorshipLevel" name="sponsorshipLevel" value={formData.sponsorshipLevel} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" data-id="element-260">
                          <option value="" data-id="element-261">Select a sponsorship level</option>
                          <option value="Platinum" data-id="element-262">Platinum ($10,000)</option>
                          <option value="Gold" data-id="element-263">Gold ($5,000)</option>
                          <option value="Silver" data-id="element-264">Silver ($2,500)</option>
                          <option value="Custom" data-id="element-265">Custom Package</option>
                        </select>
                        <ValidationError prefix="Sponsorship Level" field="sponsorshipLevel" errors={state.errors} data-id="element-266" />
                      </div>
                      <div className="md:col-span-2" data-id="element-267">
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-268">
                          Additional Information
                        </label>
                        <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-red-500 focus:border-red-500" placeholder="Please share any specific interests or questions you have about sponsorship opportunities." data-id="element-269"></textarea>
                        <ValidationError prefix="Message" field="message" errors={state.errors} data-id="element-270" />
                      </div>
                    </div>
                    <div className="mt-8" data-id="element-271">
                      <button type="submit" disabled={state.submitting} className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-3 rounded-md transition-colors disabled:bg-red-400" data-id="element-272">
                        {state.submitting ? 'Submitting...' : 'Submit Inquiry'}
                      </button>
                    </div>
                    <ValidationError errors={state.errors} data-id="element-273" />
                  </form>
                </div>}
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-274" />
    </div>;
}